<template>
    <div class="download">
        <h2 v-if="!inLlq">请在浏览器打开此页面</h2>
        <h2 v-else>如未下载请点击按钮下载<el-button @click="draw" type="success" style="position:relative;top:-4px">下载</el-button></h2>
        <div style="display:none">
            <img :src="require('@/assets/account.png')" ref="images1" />
            <canvas id="mycanvas" width='794' style="background:#ffffff"  class="my-canvas"></canvas>
        </div>
    </div>
</template>
<script>
import JsPDF from 'jspdf'
import { pageCourseSchedule1,getMsg,dateInfo } from "@/assets/js/axios.js";
export default {
    data(){
        return{
            info:null,
            listVideo:null,
            inLlq:false,
            list:[
                {
                    sub:"学习科目",
                    con:"学习内容",
                    type:"学习形式",
                    year:"年度",
                    hour:"学时"
                },
                
            ],
            width:[312,342,60,40,30]
        }
    },
    created() {
        let uid=location.search.split("=")[1]
        var u = navigator.userAgent;
        if(/MicroMessenger/g.test(u)||/Weibo/g.test(u)||/QQ/g.test(u)) {

        }else{
            this.inLlq=true
            getMsg(uid).then(res=>{
                this.info=res.data
                dateInfo.year='20'+uid.slice(4,6)
                pageCourseSchedule1(1, 1000, res.data.uid).then(
                    res => {
                        this.listVideo=res.data
                        this.listVideo.classSchedules.map(el=>{
                            let name=el.videoName
                            let nameArr0=el.videoName.split("】")
                            let nameArr1=el.videoName.split("——")
                            if(nameArr0[1]||nameArr1[1]){
                                name=nameArr0[1]||nameArr1[1]
                            }
                            this.list.push({
                                sub:el.cname,
                                con:name,
                                type:dateInfo.type,
                                year:dateInfo.year,
                                hour:el.learnCredit,
                            })
                        })
                        this.draw()
                    }
                );
            })
        }
        
    },
    mounted(){
        // this.draw()
    },
    methods:{
        
        draw(){
            
            console.log(this.list.length-37>0)
            console.log(Math.ceil((this.list.length-34)/37))
            let page=this.list.length-31>0?Math.ceil((this.list.length-31)/36)+1:1
            let canvas = document.getElementById("mycanvas");
            let context = canvas.getContext("2d");
            let width=794
            let height=1123*page
            canvas.setAttribute("width",width)
            canvas.setAttribute("height",height)
            context.fillStyle = "#fff";
            context.fillRect(0, 0, width, height);
            let left=5
            context.fillStyle='#000000'
            context.font = "16px Microsoft YaHei";

            context.fillText('学习证明-课程详情表', left, 40);
            context.fillText('学习证明-课程详情表', left, 40);
            context.fillText("姓名："+this.info.realName,left,70)
            context.fillText("身份证号码："+this.info.identityNum,left,100)
            context.fillText("工作单位："+this.info.company,left,130)
            context.fillText("姓名："+this.info.realName,left,70)
            context.fillText("身份证号码："+this.info.identityNum,left,100)
            context.fillText("工作单位："+this.info.company,left,130)
            context.fillRect(left,150,width-left*2,1);
            context.font = "12px Microsoft YaHei";
            context.fillText('课程明细表', 347, 190);
            context.fillText('课程明细表', 347, 190);
            context.strokeStyle='#000000'
            context.lineWidth=1;
            context.strokeRect(left,170,width-left*2,30);
            context.strokeRect(left,170,width-left*2,30);
            context.font = "12px Microsoft YaHei";
            let heights=200
            this.list.map((el,index)=>{
                if(heights%1123>1092){
                    heights=Math.ceil(heights/1123)*1123+20
                }
                let i=0;
                let width=0
                for(let item in el){
                    context.fillStyle='#66666'
                    context.fillText(el[item], 5+width+left, heights+20);
                    context.fillStyle='#000000'
                    context.strokeRect(width+left,heights,this.width[i],30);
                    context.strokeRect(width+left,heights,this.width[i],30);
                    width+=this.width[i]
                    i++
                }
                heights+=30
            })
            context.drawImage(this.$refs.images1,500,150,100,100);
            let pageData = canvas.toDataURL("image/jpg", 1.0);
            let PDF = new JsPDF('p','mm','a4')
            var position=0
            console.log(pageData.width)
            for(let i=0;i<page;i++){
                PDF.addImage(pageData,'JPEG',0,position)
                if(i<page-1){
                    PDF.addPage()
                    position-=297.15
                }
            }
            PDF.save("学习证明.pdf")
        }
    }
}
</script>

<style scoped lang="less">
.download{
    margin:60px auto;
    text-align: center;
    min-height: 100vh;
    line-height: 50px;;
}
</style>


// WEBPACK FOOTER //
// src/components/download.vue